import { useTranslation } from 'react-i18next'

import { InputWithLabel, TextArea } from '@reveni-io/reveni-ui'

import { descriptionRows, nameErrorType } from './constants'
import * as Styles from './styles'

const VisibilityCriterionBasicInfo = ({ name, description, onChange, errors, disabled }) => {
  const { t } = useTranslation()

  const nameError = errors.some(error => error.type === nameErrorType)

  const handleChangeName = event => onChange({ name: event.target.value })

  const handleChangeDescription = event => onChange({ description: event.target.value })

  return (
    <Styles.Container id={nameErrorType}>
      <InputWithLabel
        label={t('Nombre del criterio')}
        value={name}
        onChange={handleChangeName}
        fullWidth
        disabled={disabled}
        error={nameError}
        helperText={nameError && t('Este campo es obligatorio')}
      />
      <TextArea
        label={t('Descripción')}
        value={description}
        onChange={handleChangeDescription}
        fullWidth
        rows={descriptionRows}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default VisibilityCriterionBasicInfo
